import { FC, useEffect, useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";

import { GeographicalStatisticsObject, StatisticsApiResponse } from "./types";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolume";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import Top10Diagnoses from "src/components/manufacturer/top10Diagnoses";
import Top10Payors from "src/components/manufacturer/top10Payors";
import { AuthContext } from "../../context/authContext";
import KAMs from "src/components/KAMs";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import RAMs from "src/components/RAMs";




const Manufacturer: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();

  const [queryParams, changeQueryParams] = useState({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    // filter: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: "index",
    soc_value: searchParams.get("soc_value") || "",
    drug_id: searchParams.get("drug_id") || "",
    user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
    regional_manager_id: searchParams.get("regional_manager_id") || "",
  });

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate() + 1),
          "yyyy-MM-dd"
        ),
        period: "",
        // filter: "",
        // time: "",
        type: "index",
        soc_value: "",
        drug_id: "",
        user_id: "",
        regional_manager_id: "",
      });
    } else {
     // console.log("updatedQueries", updatedQueries)
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = (period: string) => {
    const updatedQueries = {
      ...queryParams,
      period,
    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader />

      {statisticsData && (
        <CaseFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
          rsd={statisticsData.data.rsd}
          regional_managers={statisticsData.data.regional_managers_dropdown_data}

        />
      )}
      {statisticsData && (
        <CaseVolume StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} />
      )}
      {statisticsData && (
        <Top10Payors StatisticsObjectType={statisticsData.data} />
      )}
      {statisticsData && (
        <Top10Diagnoses StatisticsObjectType={statisticsData.data} />
      )}
      {userData?.ref_type === "Manufacturer" && statisticsData && statisticsData.data  ?

        <div className="row">
         
          <div className="col-12 col-sm-12 col-md-6 mt-3 overflow-auto">
            { statisticsData.data.regional_managers && statisticsData.data.regional_managers.data &&
              <RAMs
                data={statisticsData.data.regional_managers.data}
                ecr_total={statisticsData.data.rsd.ecr_total}
                case_total={statisticsData.data.rsd.case_total}
                start_date={queryParams.start_date}
                end_date={queryParams.end_date}
                title="Regional Managers"
              />}
          </div>
           <div className="col-12 col-sm-12 col-md-6 mt-3 overflow-auto">
            { statisticsData.data.rsd && statisticsData.data.rsd.data &&
              <KAMs
                data={statisticsData.data.rsd.data}
                ecr_total={statisticsData.data.rsd.ecr_total}
                case_total={statisticsData.data.rsd.case_total}
                start_date={queryParams.start_date}
                end_date={queryParams.end_date}
                title="Account Director"
              />}
          </div>
        </div> 
        : 
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 mt-3 overflow-auto">
            {statisticsData && statisticsData.data  && statisticsData.data.rsd && statisticsData.data.rsd.data &&
              <KAMs
                data={statisticsData.data.rsd.data}
                ecr_total={statisticsData.data.rsd.ecr_total}
                case_total={statisticsData.data.rsd.case_total}
                start_date={queryParams.start_date}
                end_date={queryParams.end_date}
                title="Account Director"
              />}
          </div>
          </div>
      }
      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
      <FooterText footerType="black" />
    </div>
  );
};

export default Manufacturer;
